/*
 *
 * EditCompanyPopup
 *
 * @version 1.0.0
 * @author a.mancuso
 * @since 02-Apr-2025
*/

import EditCompanyPopup from './EditCompanyPopupContainer'

export default EditCompanyPopup
